"use client";

import { useState } from "react";
import { useTranslations } from "next-intl";
import Image from "next/image";
import olofssonbgvector from "@/assets/backgroundVectors/olofssonbgvector.png";
import familjeOlofssonnMobileVector from "@/assets/backgroundVectors/familjeOlofssonnMobileVector.png";

export default function OwnerCard2({
  name,
  shortDescription,
  fullDescriptionParaOne,
  fullDescriptionParaTwo,
  image,
  bgColor
}) {
  const t = useTranslations();
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div
      className="relative rounded-3xl overflow-visible"
      style={{ backgroundColor: bgColor || "#D9E8F1" }}
    >
      <Image
        src={familjeOlofssonnMobileVector}
        alt=""
        className="md:hidden absolute top-100 right-0 w-[62%]"
        loading="lazy"
      />
      <Image
        src={olofssonbgvector}
        alt=""
        className="hidden md:block absolute bottom-0 left-0 md:w-[35%] [@media(min-width:2400)]:w-100 z-0"
        loading="lazy"
      />
      <div className="flex flex-col md:flex-row items-end">
        {/* Image - left side */}
        {image && (
          <div className="hidden md:block  md:w-[30%] relative self-stretch md:left-[12%]">
            <Image
              src={image}
              alt={name}
              width={600}
              height={500}
              unoptimized
              className={`absolute bottom-0 left-0 w-full object-contain object-bottom ${
                isExpanded ? "h-full" : "h-[120%]"
              } transition-all duration-500`}
            />
          </div>
        )}

        {/* Text content - right side */}
        <div
          className={`flex flex-col gap-4 pl-[9%] pr-[9%] md:pl-[26%] md:pr-0 pb-0 ${isExpanded ? "md:pb-15" : "md:pb-30"} pt-10  md:pt-15 md:w-[62%] z-10 transition-all duration-500`}
        >
          <h3 className="heading-micro-text text-ff-purple">{name}</h3>
          <p className="body-small-copy-text text-ff-purple">{shortDescription}</p>
          <div
            className="grid transition-[grid-template-rows] duration-500 ease-in-out"
            style={{ gridTemplateRows: isExpanded ? "1fr" : "0fr" }}
          >
            <div className="overflow-hidden">
              <div className="flex flex-col gap-4">
                <p className="body-small-copy-text text-ff-purple">{fullDescriptionParaOne}</p>
                <p className="body-small-copy-text text-ff-purple">{fullDescriptionParaTwo}</p>
              </div>
            </div>
          </div>
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="text-ff-purple body-small-copy-text underline self-start cursor-pointer"
          >
            {isExpanded ? t("owners.read_less") : t("owners.read_more")}
          </button>
        </div>
      </div>

      {/* Mobile image - below text */}
      {image && (
        <div className="md:hidden">
          <Image
            src={image}
            alt={name}
            width={400}
            height={350}
            unoptimized
            className="w-[80%] relative left-5"
          />
        </div>
      )}
    </div>
  );
}
